import React from 'react';

import svg from './assets/icons-24-search.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconSearch = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-search" />
);
